import { atom } from 'recoil'

export const soundState = atom<boolean>({
  key: 'app/sound',
  default: false,
})

export type BgmType = 'normal' | 'none'

export type BgmState = { prev: BgmType; current: BgmType }

export const bgmState = atom<BgmState>({
  key: 'app/bgm',
  default: { prev: 'none', current: 'none' },
})

//
export const freqState = atom<Uint8Array>({
  key: 'app/freq',
  default: new Uint8Array(512),
})
